import { LabMDM } from './../../masterdata/models/lab';
export class ReactionSetRequestDTO {
  sample : any;
  primers : any[];
  lab: LabMDM;
}
